import appSettings from '@/data/appSettings.json'
import catalogItems from '@/data/catalogItems.json'
import categories from '@/data/categories.json'
import customFields from '@/data/customFields.json'
import events from '@/data/events.json'
import images from '@/data/images.json'
import patrons from '@/data/patrons.json'

export default {
  appSettings,
  catalogItems,
  categories,
  customFields,
  events,
  images,
  patrons
}
